import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import api from '../../services/api';

import Header from '../../components/header';
import TitlePage from '../../components/title-page';
import PublisherForm from "../../components/forms/publisher-form";


export default class PublisherCC extends Component {
	state = {
		id: 0,
		publisher_name: "",
		generalName: "",
		general_email: "",
		general_phone: "",
		collaborators: [],
		action_collaborator_form: "",
		collaborator_id: "",
		collaborator_name: "",
		collaborator_email: "",
		collaborator_office: [],
		collaborator_phone: "",
		error_publisher: "",
		success_publisher: "",
		error_collaborator: "",
		success_collaborator: "",
		redirect: false,
	}

	componentDidMount () {
		//if page reloads without close any modal
		document.querySelector('body').classList.remove("no-scroll");

		const id = this.props.match.params.id;
		this.setState({id});
	
		if (parseInt(id) !== 0) {
			this.loadPublisher(id);
			this.loadCollaborators(id);
			this.setState({action_collaborator_form: "Add New CC Collaborator"});
		}
	}

	loadPublisher = async (id) => {
		try {
			const response = await api.get(`publishers/${id}`);
			this.setState({
				publisher_name: response.data.name,
				generalName: response.data.contact_name,
				general_email: response.data.email,
				general_phone: response.data.phone,
			})
		} catch(error) {
			console.log(error);
		}
	}

	loadCollaborators = async (id) => {
		try {
			const response = await api.get(`publishers/${id}/employeescc`);
			if(response.data.length > 0) {
				this.setState({
					action_collaborator_form: "",
					collaborators: response.data,
				})
			} else {
				this.setState({
					action_collaborator_form: "Add New CC Collaborator",
					collaborator: {
						id: 0
					},
				})
			}
		} catch(error) {
			console.log(error);
		}
	}

	getLastPublisher = async (e) => {
		try {
			const response = await api.get(`publishers`);
			const lastItem = response.data.slice(-1);
			this.setState({
				id: lastItem[0].id,
				redirect: true
			});
		} catch (error) {
			console.log(error);
		}
	}

	hendleDelete = async (id) => {
		try {
			await api.delete(`publishers/${this.state.id}/employeescc/${id}`);
			this.loadCollaborators(this.state.id);
		} catch(error) {
			console.log(error);
		}
	}

	onChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	}

	hendleCollaborator = async (e, id) => {
		e.preventDefault();

		const { collaborator_name, collaborator_email, collaborator_phone } = this.state;

		if (!collaborator_name || !collaborator_email || !collaborator_phone) {
			this.setState({ success_collaborator: "" });
			this.setState({ error_collaborator: "Fill in all fields" });
		} else {
			try {
				if(this.state.action_collaborator_form === "Add New CC Collaborator") {
					this.setState({ error_collaborator: "" });
					document.querySelector('[data-component="form"].collaborator-form .btn-save').classList.add("load");
					await api.post(`publishers/${this.state.id}/employeescc`, { name: collaborator_name, email: collaborator_email, /*office_post:tags,*/ phone: collaborator_phone });
					document.querySelector('[data-component="form"].collaborator-form .btn-save').classList.remove("load");
					this.setState({ success_collaborator: "Collaborator added successfully" });
				}
				else {
					document.querySelector('[data-component="form"].collaborator-form .btn-save').classList.add("load");
					await api.put(`publishers/${this.state.id}/employeescc/${id}`, { name: collaborator_name, email: collaborator_email, /*office_post:tags,*/ phone: collaborator_phone });
					document.querySelector('[data-component="form"].collaborator-form .btn-save').classList.remove("load");
					this.setState({ success_collaborator: "Collaborator updated successfully" });
				}

				this.loadCollaborators(this.state.id);
			} catch (error) {
				console.log(error);
			}
		}
	}

	openFormCollaborator = (id, action) => {
		this.setState({
			success_collaborator: "",
			error_collaborator: "",
		});

		if(action === "edit") {
				const collaborator = this.state.collaborators.filter( item => {
					return item.id === id;
				})

				this.setState({
					action_collaborator_form: "Edit Collaborator",
					collaborator_id: collaborator[0].id,
					collaborator_name: collaborator[0].name,
					collaborator_email: collaborator[0].email,
					collaborator_phone: collaborator[0].phone
				});
		} else {
			this.setState({
				action_collaborator_form: "Add New CC Collaborator",
				collaborator_id: 0,
				collaborator_name: "",
				collaborator_email: "",
				collaborator_office: [],
				collaborator_phone: "",
			});
		}
	}

	closeFormCollaborator = () => {
		if(this.state.collaborators.length) {
			this.setState({
				action_collaborator_form: "",
				collaborator: null,
			});
		}
	}
	render() {
		//Redirect to publisher edit page
		if (this.state.redirect) {
			return <Redirect to={`/list-publishers/1`} />
		}
		
		const setRedirect = (status) => {
			this.setState({
				redirect: status
			});
		}
		//Button submit form collaborator
		let buttonSaveNewCollaborator;
		if(this.state.action_collaborator_form === "Add New CC Collaborator") {
			buttonSaveNewCollaborator = <button type="submit" className="btn blue-light btn-save">Add</button>
		} else if(this.state.action_collaborator_form === "Edit Collaborator") {
			buttonSaveNewCollaborator = <button type="submit"className="btn blue-light btn-save">Save</button>
		}
		
		let buttonCancelNewCollaborator;
		if(this.state.collaborators.length > 0) {
			buttonCancelNewCollaborator = <span className="btn grey btn-delete" onClick={() => this.closeFormCollaborator("new")}>Cancel</span>
		}

		let formCollaboratorMessage;
		if(this.state.success_collaborator) {
			formCollaboratorMessage =
				<div className="label col sm-12 md-12 lg-12 collaborator-form-message">
					<p className="text text-success">{this.state.success_collaborator}</p>
				</div>
		}

		if(this.state.error_collaborator) {
			formCollaboratorMessage =
				<div className="label col sm-12 md-12 lg-12 collaborator-form-message">
					<p className="text text-error">{this.state.error_collaborator}</p>
				</div>
		}

		//Form collaborator
		let newCollaborator;
		if(this.state.action_collaborator_form === "Add New CC Collaborator" || this.state.action_collaborator_form === "Edit Collaborator") {
			newCollaborator = 
				<div className="new-collaborator">
					<strong className="collaborators-title">{this.state.action_collaborator_form}</strong>

					<form className="row flex collaborator-form" data-component="form" onSubmit={(e) => this.hendleCollaborator(e, this.state.collaborator_id)}>
						<div className="label col sm-12 md-6 lg-6">
							<label htmlFor="collaborator_name">Collaborator name</label>
							<input
								autoComplete="collaborator_name"
								id="collaborator_name"
								name="collaborator_name"
								type="text"
								placeholder="Publisher collaborator name"
								value={this.state.collaborator_name}
								onChange={e => this.onChange(e)}
							/>
						</div>
						<div className="label col sm-12 md-6 lg-6">
							<label htmlFor="collaborator_email">Collaborator Email</label>
							<input
								id="collaborator_email"
								autoComplete="collaborator_email"
								name="collaborator_email"
								type="email"
								placeholder="Publisher collaborator email"
								value={this.state.collaborator_email}
								onChange={e => this.onChange(e)}
							/>
						</div>

						<div className="label col sm-12 md-6 lg-6">
							<label htmlFor="collaborator_phone">Collaborator Phone number</label>
							<input
								autoComplete="collaborator_phone"
								id="collaborator_phone"
								name="collaborator_phone"
								type="tel"
								placeholder="Publisher collaborator phone"
								value={this.state.collaborator_phone}
								onChange={e => this.onChange(e)}
							/>
						</div>

						<div className="label col sm-12 md-12 lg-12 actions">
							{buttonCancelNewCollaborator}
							{buttonSaveNewCollaborator}
						</div>
						
						{formCollaboratorMessage}
					</form>
				</div>
		} else {
			newCollaborator = "";
		}

		//Collaborator list
		let collaboratorList;
		if(this.state.collaborators.length > 0 && this.state.id !== 0){
			collaboratorList = 
				<div data-component="collaborators-list" className="collaborators">
					<strong className="collaborators-title">{this.state.publisher_name} Collaborators "(CC)"</strong>

					<div data-component="collaborators-table">
						<div className="collaborators-table-header">
							<div className="col-inverse flex align-center sm-4 md-4 lg-4">
								<strong className="body-title">Collaborator name</strong>
							</div>
							<div className="col-inverse flex align-center sm-4 md-4 lg-4">
								<strong className="body-title">Email</strong>
							</div>
							<div className="col-inverse flex align-center sm-8 md-8 lg-8">
								<strong className="body-title">Phone</strong>
							</div>
							<div className="col-inverse flex align-center sm-8 md-6 lg-6 header-actions">
								<strong className="body-title">Action</strong>
							</div>
						</div>

						<div className="collaborators-table-body">
							{this.state.collaborators.map(collaborator => (
								<div className="table-item" key={`collaborator-${collaborator.id}`}>
									<div className="col-inverse flex align-center sm-1 md-1 lg-4">
										<p className="body-text">{collaborator.name}</p>
									</div>
									<div className="col-inverse flex align-center sm-1 md-1 lg-4">
										<a className="body-text link" href={"mailto:"+collaborator.email}>{collaborator.email}</a>
									</div>
									<div className="col-inverse flex align-center sm-2 md-1 lg-8">
										<p className="body-text"> {collaborator.phone} </p>
									</div>
									<div className="col-inverse flex align-center justfy-center sm-2 md-2 lg-6 body-actions">
										<button onClick={() => this.hendleDelete(collaborator.id)} className="btn grey">delete</button>
										<button onClick={() => this.openFormCollaborator(collaborator.id, "edit")} className="btn grey">edit</button>
										<button /*onClick={() => this.openFormCollaborator(collaborator.id, "edit")} */className="btn grey">add to</button>
									</div>
								</div>
							))}
						</div>
					</div>

					<button className="btn blue register-collaborator" onClick={() => this.openFormCollaborator("new")}>Register new CC collaborator</button>
					<div>
						<Link to={`/publisher/${this.state.id}`} className="btn blue register-collaborator" title="">
							View Publishers
						</Link>
					</div>
				</div>
		}

		let publisherForm;
		if(this.state.publisher_name !== "") {
			publisherForm =
				<div>
					<PublisherForm
						id={this.state.id}
						name={this.state.publisher_name}
						contactName={this.state.generalName}
						email={this.state.general_email}
						phone={this.state.general_phone}
						finish={setRedirect}
						cancelLink={"/list-publishers/1"}
					/>
				</div>
		} else {
			publisherForm =
				<PublisherForm
					id={0}
					name={""}
					contactName={""}
					email={""}
					phone={""}
					finish={setRedirect}
					cancelLink={"/list-publishers/1"}
				/>
		}

		return (
			<div data-page="publisher">
				<Header/>

				<TitlePage title="Add a CC Publisher Collaborator"/>

				<div className="container-fluid" data-component="content-plublisher">
					<div className="container gutter">
						{/*publisherForm*/}
						{collaboratorList}
						{newCollaborator}
					</div>
				</div>

			</div>
		)
	};
}